<div fxLayout="row" class="background">
  <div fxFlex="70" fxFlexOffset="20%">

    <div fxLayout="row" class="tablaCom">
      <div fxFlex=120 fxFlexOffset="-25%">
        <mat-card class="mat-elevation-z0">
          <div fxLayout="row" fxLayoutAlign="space-between center">
            <p fxFlex="30" class="clientData">Emperatriz Dominguez 77050670 emperatriz@dominguez.com</p>
            <p fxFlex="30" class="receiptData">RECIBO Numero de pedido: #3419 Fecha:19-Ene-2021</p>
          </div>
          <table mat-table [dataSource]="dataSource" class="tabla">

            <!-- Codigo Column -->
            <ng-container matColumnDef="nombre">
              <th mat-header-cell *matHeaderCellDef> NOMBRE DEL ARTÍCULO </th>
              <td mat-cell *matCellDef="let element">{{element.nombre}}</td>
            </ng-container>

            <!-- Store Column  -->
            <ng-container matColumnDef="precio">
              <th mat-header-cell *matHeaderCellDef>PRECIO </th>
              <td mat-cell *matCellDef="let element"> {{element.precio}}</td>
            </ng-container>

            <!-- Status Column  -->
            <ng-container matColumnDef="cantidad">
              <th mat-header-cell *matHeaderCellDef>CANTIDAD </th>
              <td mat-cell *matCellDef="let element">{{element.cantidad}}</td>
            </ng-container>

            <!-- User Column  -->
            <ng-container matColumnDef="total">
              <th mat-header-cell *matHeaderCellDef>TOTAL</th>
              <td mat-cell *matCellDef="let element"> {{element.total}} </td>
            </ng-container>


            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

          </table>

          <p class="footerReceipt">Método de pago: paypal</p>

        </mat-card>

      </div>
    </div>
  </div>
</div>
